import { ILibreNode } from '@/contracts/modules/libre/entities/ILibreNode'
import { ILibrePlace } from '@/contracts/modules/libre/entities/ILibrePlace'
import { ILibreData } from '@/contracts/modules/libre/entities/ILibreData'
import { EnumLibreKind } from '@/contracts/modules/libre/enum/EnumLibreKind'

export class LibreNode implements ILibreNode {
  constructor(
    private uuid: string,
    private place: ILibrePlace,
    private data: ILibreData,
    private removed: boolean,
    private updatedAt: string | null,
    private readable = true,
  ) {}

  /** Узел, который не расшифровался: в дереве не показывается, виден в отдельном списке */
  static unreadable(uuid: string, removed: boolean, updatedAt: string | null): LibreNode {
    const data: ILibreData = { kind: EnumLibreKind.TEXT, tags: [], content: '', attrs: {}, actualFrom: '0000-00-00', actualTo: null }
    return new LibreNode(uuid, { parent: null, position: '' }, data, removed, updatedAt, false)
  }

  getUuid(): string {
    return this.uuid
  }

  getParent(): string | null {
    return this.place.parent
  }

  getPosition(): string {
    return this.place.position
  }

  getKind(): EnumLibreKind {
    return this.data.kind
  }

  getTags(): string[] {
    return [...this.data.tags]
  }

  getContent(): string {
    return this.data.content
  }

  getAttrs(): Record<string, string> {
    return { ...this.data.attrs }
  }

  getActualFrom(): string {
    return this.data.actualFrom
  }

  getActualTo(): string | null {
    return this.data.actualTo
  }

  isActualOn(date: string): boolean {
    return this.data.actualFrom <= date && (this.data.actualTo === null || this.data.actualTo > date)
  }

  isRemoved(): boolean {
    return this.removed
  }

  isReadable(): boolean {
    return this.readable
  }

  getUpdatedAt(): string | null {
    return this.updatedAt
  }

  getPlace(): ILibrePlace {
    return { ...this.place }
  }

  getData(): ILibreData {
    return { ...this.data, tags: [...this.data.tags], attrs: { ...this.data.attrs } }
  }
}
